import { render, staticRenderFns } from "./TBmConfigModal.vue?vue&type=template&id=04bf763e&"
import script from "./TBmConfigModal.vue?vue&type=script&lang=js&"
export * from "./TBmConfigModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04bf763e')) {
      api.createRecord('04bf763e', component.options)
    } else {
      api.reload('04bf763e', component.options)
    }
    module.hot.accept("./TBmConfigModal.vue?vue&type=template&id=04bf763e&", function () {
      api.rerender('04bf763e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basedata/modules/TBmConfigModal.vue"
export default component.exports